import React, { useEffect, useRef } from 'react';
function useReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => el.classList.add('in-view'), delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.08
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
export function Testimonial() {
  const ref = useReveal();
  return <section className="w-full pt-8 pb-20 md:pt-12 md:pb-28 dark-section" style={{
    background: 'var(--bg)'
  }} aria-label="Testimonial" data-id="element-237" data-mp="7di4vfwmphpm">
      <div ref={ref} className="reveal content-wrap grid grid-cols-1 items-center gap-12 px-6 md:grid-cols-2 md:gap-20 md:px-12" data-id="element-238" data-mp="cb9shxq8qho0">
        <div className="overflow-hidden rounded-2xl" data-id="element-239" data-mp="2x2k66ckak8kd">
          <img src="https://i.imgur.com/vMm7wb5.gif" alt="Narra Health app preview" loading="lazy" className="block h-auto w-full" data-id="element-240" data-mp="2x44zjyuvdlgn" />
        </div>

        <figure className="flex flex-col items-start text-left" data-id="element-241" data-mp="3muw88ohy8zrg">
          <blockquote data-id="element-242" data-mp="5lhnvlczrrfr">
            <p className="text-lg md:text-xl leading-relaxed mb-5" style={{
            maxWidth: '44ch',
            color: 'var(--fg)'
          }} data-id="element-243" data-mp="5lzk4hznm5no">
              "Stella and her team have been our right hand in building Narra
              Health. From the very beginning, we never saw them as just a
              service provider, but as true team members who stepped into our
              shoes, understood our mission, and rallied alongside us for the
              cause we deeply care about. Narra Health would not exist today
              without Stella and her team."
            </p>
            <p className="font-aspekta text-base md:text-lg leading-relaxed" style={{
            maxWidth: '44ch',
            color: 'var(--muted)'
          }} data-id="element-244" data-mp="xbvvizuew7iz">
              "Their product managers, designers, engineers, developers, and the
              entire team have played a vital role in turning our ideas into
              something real and meaningful. There is no other product team we
              trust more."
            </p>
          </blockquote>
          <figcaption className="mt-8 flex items-center gap-4" data-id="element-245" data-mp="1abeio7we580s">
            <img src="https://cdn.magicpatterns.com/uploads/i4TJBBrfNgK9GYJdVSXr32/karina_image.jpg" alt="Karina Garcia" className="h-12 w-12 flex-shrink-0 rounded-full" style={{
            objectFit: 'cover'
          }} data-id="element-246" data-mp="1f3enoerbir48" />
            <div data-id="element-247" data-mp="1o5e5vae2k18r">
              <p className="font-aspekta text-base tracking-tight" style={{
              color: 'var(--fg)'
            }} data-id="element-248" data-mp="1t2xjq96uuc06">
                Karina Garcia
              </p>
              <p className="font-aspekta text-sm" style={{
              color: 'var(--muted)'
            }} data-id="element-249" data-mp="1y18sshpbsihc">
                Co-founder & CEO · Narra Health
              </p>
            </div>
          </figcaption>
        </figure>
      </div>
    </section>;
}